<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { getDefaultLocale } from '@/pages/global/utils/locale'
import Navbar from '@/pages/global/verifyMetaData/components/Navbar.vue'
import MetaDataCard from '@/pages/global/verifyMetaData/components/MetaDataCard.vue'
import PhotoLocation from '@/pages/global/verifyMetaData/components/PhotoLocation.vue'
import PhotoVerification from '@/pages/global/verifyMetaData/components/PhotoVerification.vue'
import Footer from '@/pages/global/verifyMetaData/components/Footer.vue'
import todayAxios from '@/utils/global/todayAxiosGlobal'
import { useRoute } from 'vue-router'
import sensor from '@/utils/saUtilsGlobal'
import ErrorStatus from '@/pages/global/verifyMetaData/components/ErrorStatus.vue'

const route = useRoute()
const photoCode = computed(() => route.params.photoCode)
const textType = computed(() => route.params.textType)

// 检测是否为阿拉伯语（RTL语言）
const defaultLocal = getDefaultLocale()
const isRTL = ref(defaultLocal === 'ar')

const metaData = ref()
const showErrorStatus = ref(false)
/**
 * 获取照片元数据
 * */
const getMetaData = async () => {
  const { data } = await todayAxios.post('/next/photo/code/location/query', {
    photoCode: photoCode.value
  })
  if (data.code !== 200) {
    showErrorStatus.value = true
    return
  }
  if (data.data.status === 2) {
    showErrorStatus.value = true
  }
  metaData.value = data.data.photoInfo
}

onMounted(() => {
  handleTrack('enter', {
    url: window.location.href
  })
})

watch(
  () => route.params,
  (newVal) => {
    if (Object.keys(newVal).length === 0) {
      return
    }
    photoCode.value = newVal.photoCode
    textType.value = newVal.textType
    getMetaData()
  },
  { immediate: true }
)

/**
 * 上报埋点
 * */
const handleTrack = (actionType, params) => {
  sensor.track('H5_get_action_page_photo_info', {
    actionType,
    ...params
  })
}
</script>

<template>
  <Navbar @track="handleTrack" />
  <div class="verify-meta-content" :dir="isRTL ? 'rtl' : 'ltr'">
    <ErrorStatus v-if="showErrorStatus" />
    <PhotoLocation
      @track="handleTrack"
      :metaData="metaData"
      :showErrorStatus="showErrorStatus"
    />
    <MetaDataCard :metaData="metaData" />
    <PhotoVerification @track="handleTrack" />
    <Footer @track="handleTrack" />
  </div>
</template>
<style lang="scss" scoped>
.verify-meta-content {
  padding: 0 20px 80px 20px;
  overflow: hidden;
}
</style>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  font-family: SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  overscroll-behavior: none;
  width: 100vw;
  height: 100vh;
}

img {
  width: 100%;
  height: 100%;
}
</style>
